// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3UG1Z","head":"ProcedureTableInfo_head__1RV6L"};